<template>
    <section class="sessao-imovel">
        <div class='row'>
            <div class="col-xs-12">
                <h3><icon name="home"></icon> Dados do imóvel</h3>
            </div>
        </div>
        
        <div class="row">
            <div class="col-xs-12 col-md-2">
                <div class="form-group" :class="{'has-error': errors.has('data.residence.zip_code')}">
                    <label for="data.residence.zip_code">CEP <span class="text-danger">*</span></label>
                    <input class="form-control" name="data.residence.zip_code" id="zip_code" type="text" v-mask="'##.###-###'" data-vv-as="CEP" 
                        v-model="residence.zip_code" v-validate="{ rules: { required: true } }" />
                    <div class="error-message" v-if="errors.has('data.residence.zip_code')">{{ errors.first('data.residence.zip_code') }}</div>
                </div>
            </div>
            <div class="col-xs-12 col-md-8">
                <div class="form-group" :class="{'has-error': errors.has('data.residence.street')}">
                    <label for="imovel_logradouro">Endereço <span class="text-danger">*</span></label>
                    <input class="form-control" name="data.residence.street" id="imovel_logradouro" type="text" data-vv-as="Logradouro" v-model="residence.street" 
                        v-validate="{ rules: { required: true }}" />
                    <div class="error-message" v-if="errors.has('data.residence.street')">{{ errors.first('data.residence.street') }}</div>
                </div>
            </div>
            <div class="col-xs-12 col-md-2">
                <div class="form-group" :class="{'has-error': errors.has('data.residence.number')}">
                    <label for="imovel_numero">Número <span class="text-danger">*</span></label>
                    <input class="form-control" name="data.residence.number" id="imovel_numero" type="text" data-vv-as="Número" v-model="residence.number" 
                        v-validate="'required|numeric'"/>
                    <div class="error-message" v-if="errors.has('data.residence.number')">{{ errors.first('data.residence.number') }}</div>
                </div>
            </div>
        </div><!-- end row -->

        <div class="row">
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.residence.complement')}">
                    <label for="imovel_complemento">Complemento</label>
                    <input class="form-control" name="data.residence.complement" id="imovel_complemento" type="text" data-vv-as="Complemento" v-model="residence.complement" />
                    <div class="error-message" v-if="errors.has('data.residence.complement')">{{ errors.first('data.residence.complement') }}</div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.residence.neighborhood')}">
                    <label for="imovel_bairro">Bairro <span class="text-danger">*</span></label>
                    <input class="form-control" name="data.residence.neighborhood" id="imovel_bairro" type="text" data-vv-as="Bairro" v-model="residence.neighborhood" 
                        v-validate="{ rules: { required: true }}" />
                    <div class="error-message" v-if="errors.has('data.residence.neighborhood')">{{ errors.first('data.residence.neighborhood') }}</div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data.residence.cidade')}">
                    <label for="imovel_cidade">Cidade <span class="text-danger">*</span></label>
                    <input class="form-control" name="data.residence.cidade" id="imovel_cidade" type="text" data-vv-as="Cidade" v-model="residence.city" 
                        v-validate="{ rules: { required: true }}" />
                    <div class="error-message" v-if="errors.has('data.residence.cidade')">{{ errors.first('data.residence.cidade') }}</div>
                </div>
            </div>
        </div><!-- end row -->

        <div class="row">
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data[residence]][state]')}">
                    <label for="data.residence.state">{{ state.label }} <span class="text-danger">*</span></label>
                    <v-select 
                        :options="state.options"
                        label="text"
                        :filterable="true"
                        :reduce="x => x.id"
                        name="data[residence]][state]" 
                        :id="state.id" 
                        :placeholder="state.placeholder" 
                        v-validate="{ rules: { required: true } }" 
                        :data-vv-as="state.label"
                        v-model="residence.state"
                        :key="residence.state"
                        class="vueSelect"
                    >
                        <span slot="no-options">Digite 3 ou mais caracteres para buscar</span>
                    </v-select>
                    <div class="error-message" v-if="errors.has('data[residence]][state]')">{{ errors.first('data[residence]][state]') }}</div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data[residence][walk]')}">
                    <label for="imovel_walk">{{ flooring.label }} <span class="text-danger">*</span></label>
                    <v-select 
                        :options="flooring.options"
                        label="text"
                        :filterable="true"
                        :reduce="x => x.id"
                        name="data[residence][walk]" 
                        :id="flooring.id" 
                        :placeholder="flooring.placeholder" 
                        v-validate="{ rules: { required: true } }" 
                        :data-vv-as="flooring.label" 
                        v-model="residence.walk"
                        :key="residence.walk"
                        class="vueSelect"
                    >
                        <span slot="no-options">Digite 3 ou mais caracteres para buscar</span>
                    </v-select>
                    <div class="error-message" v-if="errors.has('data[residence][walk]')">{{ errors.first('data[residence][walk]') }}</div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('data[residence][type_construction]')}">
                    <label for="typeConstruction">{{ typesConstruction.label }} <span class="text-danger">*</span></label>
                    <v-select 
                        :options="typesConstruction.options"
                        label="text"
                        :filterable="true"
                        :reduce="x => x.id"
                        name="data[residence][type_construction]" 
                        :id="typesConstruction.id" 
                        :placeholder="typesConstruction.placeholder" 
                        v-validate="{ rules: { required: true } }" 
                        :data-vv-as="typesConstruction.label" 
                        v-model="residence.type_construction" 
                        :key="residence.type_construction"
                        class="vueSelect"
                    >
                        <span slot="no-options">Digite 3 ou mais caracteres para buscar</span>
                    </v-select>
                    <div class="error-message" v-if="errors.has('data[residence][type_construction]')">{{ errors.first('data[residence][type_construction]') }}</div>
                </div>
            </div>
        </div><!-- end row -->

        <div class="row">
            <div class="col-xs-12 col-md-12">
                <div class="form-group" :class="{'has-error': errors.has('data[residence][location]')}">
                    <label for="location">{{ locations.label }} <span class="text-danger">*</span></label>
                    <v-select 
                        :options="locations.options"
                        label="text"
                        :filterable="true"
                        :reduce="x => x.id"
                        name="data[residence][location]" 
                        :id="locations.id" 
                        :placeholder="locations.placeholder" 
                        v-validate="{ rules: { required: true } }" 
                        :data-vv-as="locations.label" 
                        v-model="residence.location"
                        :key="residence.location"
                        class="vueSelect"
                    >
                        <span slot="no-options">Digite 3 ou mais caracteres para buscar</span>
                    </v-select>
                    <div class="error-message" v-if="errors.has('data[residence][location]')">{{ errors.first('data[residence][location]') }}</div>
                </div>
            </div>
        </div><!-- end row -->
        <div class="row">
            <!-- <div class="col-xs-12 col-md-12">
                <div class="form-group" :class="{'has-error': errors.has('data[residence][activity]')}">
                    <label for="activity">{{ activities.label }} <span class="text-danger">*</span></label>
                    <v-select 
                        :options="activities.options"
                        label="text"
                        :filterable="true"
                        :reduce="x => x.id"
                        name="data[residence][activity]" 
                        :id="activities.id" 
                        :placeholder="activities.placeholder" 
                        v-validate="{ rules: { required: true } }" 
                        :data-vv-as="activities.label" 
                        v-model="residence.activity"
                        :key="residence.activity"
                        class="vueSelect"
                    >
                        <span slot="no-options">Digite 3 ou mais caracteres para buscar</span>
                    </v-select>
                    <div class="error-message" v-if="errors.has('data[residence][activity]')">{{ errors.first('data[residence][activity]') }}</div>
                </div>
            </div> -->

            <!-- <div class="col-xs-12 col-md-12" v-if="residence.activity == '23'">
                <div class="form-group" :class="{'has-error': errors.has(activities.CnaeName)}">
                    <label for="activity">Atividade CNAE<span class="text-danger">*</span></label>
                        <select2 
                            :options="activities.cnaeOptions" 
                            :name="activities.CnaeName" 
                            id="activity_cnae" 
                            :disabled="activities.disabled" 
                            :placeholder="activities.placeholder" 
                            data-vv-as="Atividade CNAE" 
                            v-model="residence.activity_cnae"                        
                            v-validate="{ rules: { required: residence.activity == '23' }}"
                            :ajax="searchCnae()"
                        ></select2>
                    <div class="error-message" v-if="errors.has(activities.CnaeName)">{{ errors.first(activities.CnaeName) }}</div>
                    <span>{{ errors }}</span>
                </div>
            </div> -->

            <div  v-for="activity in activityList" :key="activity.company" class="col-xs-6 col-md-6" v-if="render_cnae_select">
                <div class="form-group" :class="{'has-error': errors.has(`data[residence][activity_cnae_company][${activity.company}]`)}">
                    <label for="activity_cnae_company">Atividades CNAE da {{ capitalizeFirstLetter(activity.description) }}<span class="text-danger">*</span></label>
                    <select2
                        :options="activity.cnaeOptions"
                        :name="`data[residence][activity_cnae_company][${activity.company}]`"
                        :id="activity.company"
                        placeholder='Carregando...'
                        data-vv-as="Atividade CNAE"
                        v-model="activity.value"
                        v-validate="{ rules: { required: true } }"
                        :ajax="searchCnaeNew(activity.company)"
                    ></select2>
                    <div class="error-message" v-if="errors.has(`data[residence][activity_cnae_company][${activity.company}]`)">{{ errors.first(`data[residence][activity_cnae_company][${activity.company}]`) }}</div>
                </div>
            </div>


        </div><!-- end row -->
       
        <div class="row m-0">
            <label>Equipamentos de segurança</label>
            <div class="switch-border col-xs-12">
                <div class="row">
                    <div class="col-xs-12 col-md-4">
                        <div class="form-group" :class="{'has-error': errors.has('data.residence.local_alarm')}">
                            <div class="input-group">
                                <label class="switch">
                                <input type="checkbox" name="data.residence.local_alarm" v-model="residence.local_alarm"><span class="slider round"></span><span class="absolute-no">Alarme local</span></label>
                            </div>
                            <div class="error-message" v-if="errors.has('data.residence.local_alarm')">{{ errors.first('data.residence.local_alarm') }}</div>
                        </div>
                    </div>

                    <div class="col-xs-12 col-md-4">
                        <div class="form-group" :class="{'has-error': errors.has('data.residence.security_24h')}">
                            <div class="input-group">
                                <label class="switch">
                                <input type="checkbox" name="data.residence.security_24h" v-model="residence.security_24h"><span class="slider round"></span><span class="absolute-no">Vigilância 24 horas</span></label>
                            </div>
                            <div class="error-message" v-if="errors.has('data.residence.security_24h')">{{ errors.first('data.residence.security_24h') }}</div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-group" :class="{'has-error': errors.has('data.residence.grid_tetra_lock')}">
                            <div class="input-group">
                                <label class="switch">
                                <input type="checkbox" name="data.residence.grid_tetra_lock" v-model="residence.grid_tetra_lock"><span class="slider round"></span><span class="absolute-no">Grade e fechadura tetra</span></label>
                            </div>
                            <div class="error-message" v-if="errors.has('data.residence.grid_tetra_lock')">{{ errors.first('data.residence.grid_tetra_lock') }}</div>
                        </div>
                    </div>
                </div><!-- end row -->

                <div class="row">
                    <div class="col-xs-12 col-md-4">
                        <div class="form-group" :class="{'has-error': errors.has('data.residence.closed_circuit')}">
                            <div class="input-group">
                                <label class="switch">
                                <input type="checkbox" name="data.residence.closed_circuit" v-model="residence.closed_circuit"><span class="slider round"></span><span class="absolute-no">Circuito fechado de CFTV</span></label>
                            </div>
                            <div class="error-message" v-if="errors.has('data.residence.closed_circuit')">{{ errors.first('data.residence.closed_circuit') }}</div>
                        </div>
                    </div>

                    <div class="col-xs-12 col-md-4">
                        <div class="form-group" :class="{'has-error': errors.has('data.residence.monitored_alarm]')}">
                            <div class="input-group">
                                <label class="switch">
                                <input type="checkbox" name="data.residence.monitored_alarm" v-model="residence.monitored_alarm"><span class="slider round"></span><span class="absolute-no">Alarme monitorado</span></label>
                            </div>
                            <div class="error-message" v-if="errors.has('data.residence.monitored_alarm')">{{ errors.first('data.residence.monitored_alarm') }}</div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-group" :class="{'has-error': errors.has('data.residence.infrared_sensor')}">
                            <div class="input-group">
                                <label class="switch">
                                <input type="checkbox" name="data.residence.infrared_sensor" v-model="residence.infrared_sensor"><span class="slider round"></span><span class="absolute-no">Sensor infravermelho</span></label>
                            </div>
                            <div class="error-message" v-if="errors.has('data.residence.infrared_sensor')">{{ errors.first('data.residence.infrared_sensor') }}</div>
                        </div>
                    </div>
                </div><!-- end row -->
            </div>
        </div>
        <div class="row m-0">
            <label>Equipamentos contra incêndio</label>
            <div class="switch-border col-xs-12">
                <div class="row">
                    <div class="col-xs-12 col-md-4">
                        <div class="form-group" :class="{'has-error': errors.has('data.residence.hydrant')}">
                            <div class="input-group">
                                <label class="switch">
                                <input type="checkbox" name="data.residence.hydrant" v-model="residence.hydrant"><span class="slider round"></span><span class="absolute-no">Hidrante</span></label>
                            </div>
                            <div class="error-message" v-if="errors.has('data.residence.hydrant')">{{ errors.first('data.residence.hydrant') }}</div>
                        </div>
                    </div>

                    <div class="col-xs-12 col-md-4">
                        <div class="form-group" :class="{'has-error': errors.has('data.residence.smoke_detector')}">
                            <div class="input-group">
                                <label class="switch">
                                <input type="checkbox" name="data.residence.smoke_detector" v-model="residence.smoke_detector"><span class="slider round"></span><span class="absolute-no">Detector de fumaça</span></label>
                            </div>
                            <div class="error-message" v-if="errors.has('data.residence.smoke_detector')">{{ errors.first('data.residence.smoke_detector') }}</div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-group" :class="{'has-error': errors.has('data.residence.fire_brigade')}">
                            <div class="input-group">
                                <label class="switch">
                                <input type="checkbox" name="data.residence.fire_brigade" v-model="residence.fire_brigade"><span class="slider round"></span><span class="absolute-no">Brigada de incêndio</span></label>
                            </div>
                            <div class="error-message" v-if="errors.has('data.residence.fire_brigade')">{{ errors.first('data.residence.fire_brigade') }}</div>
                        </div>
                    </div>
                </div><!-- end row -->

                <div class="row">
                    <div class="col-xs-12 col-md-4">
                        <div class="form-group" :class="{'has-error': errors.has('data.residence.extinguisher')}">
                            <div class="input-group">
                                <label class="switch">
                                <input type="checkbox" name="data.residence.extinguisher" v-model="residence.extinguisher"><span class="slider round"></span><span class="absolute-no">Extintor</span></label>
                            </div>
                            <div class="error-message" v-if="errors.has('data.residence.extinguisher')">{{ errors.first('data.residence.extinguisher') }}</div>
                        </div>
                    </div>

                    <div class="col-xs-12 col-md-4">
                        <div class="form-group" :class="{'has-error': errors.has('data.residence.sprinkler')}">
                            <div class="input-group">
                                <label class="switch">
                                <input type="checkbox" name="data.residence.sprinkler" v-model="residence.sprinkler"><span class="slider round"></span><span class="absolute-no">Sprinkler</span></label>
                            </div>
                            <div class="error-message" v-if="errors.has('data.residence.sprinkler')">{{ errors.first('data.residence.sprinkler') }}</div>
                        </div>
                    </div>                    
                </div><!-- end row -->
            </div>
        </div>
    </section>
</template>

<script>
    import FormHelp from 'shared/modules/Help/FormHelp.vue'
    import Select2 from 'shared/modules/Select2/Select2.vue'
    import axios from 'axios'

    export default {
        components: {
            FormHelp,
            Select2,
        },
        props: {
            residence:Object
        },
        data(){
            return {
                cepRequest: {},
                flooring: {
                    disabled: true,
                    name: 'data[residence][walk]',
                    label: 'Pavimento/Andar',
                    placeholder: 'Carregando...',
                    options: []
                },
                typesConstruction: {
                    disabled: true,
                    name: 'data[residence][type_construction]',
                    label: 'Tipo de construção',
                    placeholder: 'Carregando...',
                    options: []
                },
                locations: {
                    disabled: true,
                    name: 'data[residence][location]',
                    label: 'Localização',
                    placeholder: 'Carregando...',
                    options: []
                },
                activities: {
                    disabled: true,
                    name: 'data[residence][activity]',
                    placeholder: 'Carregando...',
                    label: 'Atividade principal da empresa',
                    options: [],
                    cnaeOptions: [],
                    CnaeName: 'data[residence][activity_cnae]',
                },
                state: {
                    disabled: true,
                    name: 'data[residence]][state]',
                    label: 'Estado',
                    placeholder: 'Carregando...',
                    options: []
                },
                CnaeSearched: false,
                zipCodeCopied: '',
                activityList: [],
                deepActivityList: [],
                render_cnae_select: false
            }
        },
        computed: {
            quotation(){
                return this.$store.getters['quotation']
            },
        },
        mounted() {
            this.initPavimentos()
            this.initTiposConstrucao()
            this.initTiposLocalizacao()

            this.$root.$options.eventBus.$on("onAuthorizedToken", () => {
                this.initState()
            })

            this.$root.$options.eventBus.$on('onReceiveCompanyList', () => {
                this.initActivities()
            })
        },
        watch: {
            quotation(quotation){    
                if( ! quotation.data.data.residence )
                return

                if ( quotation.data.data.residence.zip_code )
                    this.zipCodeCopied = quotation.data.data.residence.zip_code;
                    sessionStorage.setItem(this.zipCodeCopied, JSON.stringify(quotation.data.data.residence))
                    this.residence.zip_code = quotation.data.data.residence.zip_code

                if ( quotation.data.data.residence.street )
                    this.residence.street = quotation.data.data.residence.street

                if ( quotation.data.data.residence.number )
                    this.residence.number = quotation.data.data.residence.number

                if ( quotation.data.data.residence.complement )
                    this.residence.complement = quotation.data.data.residence.complement

                if ( quotation.data.data.residence.neighborhood )
                    this.residence.neighborhood = quotation.data.data.residence.neighborhood
                
                if ( quotation.data.data.residence.city )
                    this.residence.city = quotation.data.data.residence.city

                if ( quotation.data.data.residence.state )
                    this.residence.state = quotation.data.data.residence.state

                if ( quotation.data.data.residence.walk )
                    this.residence.walk = quotation.data.data.residence.walk

                if ( quotation.data.data.residence.type_construction )
                    this.residence.type_construction = quotation.data.data.residence.type_construction

                if ( quotation.data.data.residence.location )
                    this.residence.location = quotation.data.data.residence.location

                if ( quotation.data.data.residence.activity )
                    this.residence.activity = quotation.data.data.residence.activity

                if ( quotation.data.data.residence.activity_cnae )
                    this.residence.activity_cnae = quotation.data.data.residence.activity_cnae
         
                if ( quotation.data.data.residence.local_alarm )
                    this.residence.local_alarm = quotation.data.data.residence.local_alarm

                if ( quotation.data.data.residence.security_24h )
                    this.residence.security_24h = quotation.data.data.residence.security_24h
                    
                if ( quotation.data.data.residence.grid_tetra_lock )
                    this.residence.grid_tetra_lock = quotation.data.data.residence.grid_tetra_lock
                    
                if ( quotation.data.data.residence.closed_circuit )
                    this.residence.closed_circuit = quotation.data.data.residence.closed_circuit
                    
                if ( quotation.data.data.residence.monitored_alarm )
                    this.residence.monitored_alarm = quotation.data.data.residence.monitored_alarm
                    
                if ( quotation.data.data.residence.infrared_sensor )
                    this.residence.infrared_sensor = quotation.data.data.residence.infrared_sensor
                    
                if ( quotation.data.data.residence.hydrant )
                    this.residence.hydrant = quotation.data.data.residence.hydrant

                if ( quotation.data.data.residence.smoke_detector )
                    this.residence.smoke_detector = quotation.data.data.residence.smoke_detector 
                    
                if ( quotation.data.data.residence.fire_brigade )
                    this.residence.fire_brigade = quotation.data.data.residence.fire_brigade 
                    
                if ( quotation.data.data.residence.extinguisher )
                    this.residence.extinguisher = quotation.data.data.residence.extinguisher

                if ( quotation.data.data.residence.sprinkler ){
                    this.residence.sprinkler = quotation.data.data.residence.sprinkler
                }

                if ( quotation.data.data.residence.activity_cnae_company ){
                    this.residence.activity_cnae_company = quotation.data.data.residence.activity_cnae_company
                    this.initActivities()
                }
            },
            // 'residence.activity_cnae': function(idCnae) {
            //     this.searchCnaeById(idCnae)
            // },
            activityList: {
                handler(newActivityList, oldActivityList) {
                    const diff = this.findDifference(this.deepActivityList, newActivityList)
                    this.deepActivityList = _.cloneDeep(newActivityList);
                    diff.forEach(element => {
                        this.searchCnaeByIdNew(element.value)
                    });
                },
                deep: true
            },
            'residence.zip_code': function(cep) {
                if (this.residence.zip_code.length  == 10){
                    if( sessionStorage.getItem(cep) ){
                        var cepStorage = JSON.parse(sessionStorage.getItem(this.residence.zip_code))
                        this.errors.remove('imovel[cep]')
                        this.setCep(cepStorage)
                    } else {
                        if (cep != this.zipCodeCopied){
                            axios.post(this.$root.$options.config.environment.applicationUrlApiAutomation + '/api/enterprise/version/1.0/zip-code',
                                {
                                    config: {
                                        token: this.$root.$options.config.token
                                    },
                                    data: {
                                        zip_code: this.residence.zip_code
                                    }
                                },{
                                    headers: {
                                        "Content-Type": "application/json",
                                        "Authorization": `Bearer ${this.$store.state.automationBearer}`
                                    }
                                }
                            ).then(response => {
                                if(Object.keys(response.data.data).length > 0){
                                    this.errors.remove('imovel[cep]')
                                    sessionStorage.setItem(this.residence.zip_code, JSON.stringify(response.data.data))
                                } else {
                                    this.errors.add('imovel[cep]', 'CEP não encontrado', 'cepError')
                                }
                                this.zipCodeCopied = this.zipCodeMask(response.data.data.zipcode)
                                this.setCep(response.data.data)
                            })
                        }
                    }
                }
            }
        },
        methods: {
            capitalizeFirstLetter(string) {
                return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
            },
            findDifference(oldArray, newArray) {
                return newArray.filter(newItem =>
                    !oldArray.find(oldItem => oldItem.company === newItem.company && oldItem.value === newItem.value)
                )
            },
            prepareCnaeCompany(){
                this.residence.activity_cnae_company = this.activityList
                .filter(option => option.cnaeOptions && option.cnaeOptions.length > 0)
                .map(option =>{
                    return option.cnaeOptions[0]
                })
            },
            zipCodeMask(zipCode){
                return zipCode.replace(/\D/g, '').replace(/^(\d{2})(\d{3})(\d{3})$/, '$1.$2-$3');
            },
            setCep(cepData){
                this.residence.street          = cepData.street
                this.residence.neighborhood    = cepData.neighborhood
                this.residence.city            = cepData.city
                this.residence.state           = cepData.state
            },
            initPavimentos(){
                this.flooring.placeholder = '- Selecione -'
                this.flooring.disabled    = false
                this.flooring.options = [{
                                                    id: "UPSTAIRS",
                                                    text: "Andar superior"
                                                }, 
                                                {
                                                    id: "GROUND_FLOOR",
                                                    text: "Térreo",
                                                }]

            },
            initTiposConstrucao(){
                this.typesConstruction.placeholder = '- Selecione -'
                this.typesConstruction.disabled    = false
                this.typesConstruction.options = [{
                                                    id: "WOOD",
                                                    text: "Madeira"
                                                }, 
                                                {
                                                    id: "MIXED",
                                                    text: "Mista"
                                                }, 
                                                {
                                                    id: "MASONRY",
                                                    text: "Alvenaria"
                                                }]
            },
            initTiposLocalizacao(){
                this.locations.placeholder = '- Selecione -'
                this.locations.disabled    = false
                this.locations.options = [{
                                                    id: "MARKET",
                                                    text: "Ceasa/Mercado"
                                                }, 
                                                {
                                                    id: "OTHERS",
                                                    text: "Outros",
                                                }, 
                                                {
                                                    id: "AIRPORT",
                                                    text: "Aeroporto"
                                                },
                                                {
                                                    id: "SHOPPING",
                                                    text: "Shopping"
                                                },
                                                {
                                                    id: "SUPERMARKET",
                                                    text: "Supermercado"
                                                },
                                                {
                                                    id: "COMMERCIAL_CONDOMINIUM",
                                                    text: "Condomínio comercial"
                                                }]

            },
            initActivities(){
                this.activityList = this.$store.state.enterpriseInsurers.map((company) => {
                    const has_cnae = (this.residence.activity_cnae_company).find(cnae => cnae.activity_attributes.company === company.name);
                    let result;
                    if (has_cnae !== undefined){
                        result = {
                            ...has_cnae.activity_attributes,
                            description: company.nome,
                            value: has_cnae.activity_attributes.id,
                            cnaeOptions: []
                        }
                    } else {
                        result = {
                            company: company.name,
                            description: company.nome,
                            value: "",
                            cnaeOptions: []
                        }

                    }
                    return result;
                });
                this.render_cnae_select = true
            },
            initTiposAtividade(){
                this.activities.placeholder = '- Selecione -'
                this.activities.disabled    = false
                this.activities.options = [{
                                                    id: "01",
                                                    text: "Academia"
                                                }, 
                                                {
                                                    id: "02",
                                                    text: "Açougue",
                                                }, 
                                                {
                                                    id: "03",
                                                    text: "Artigo para presentes"
                                                },
                                                {
                                                    id: "04",
                                                    text: "Bar"
                                                },
                                                {
                                                    id: "05",
                                                    text: "Beleza e Estética"
                                                },
                                                {
                                                    id: "06",
                                                    text: "Buffet"
                                                },
                                                {
                                                    id: "07",
                                                    text: "Clínica veterinária"
                                                },
                                                {
                                                    id: "08",
                                                    text: "Concessionária"
                                                },
                                                {
                                                    id: "09",
                                                    text: "Consultório médico"
                                                },
                                                {
                                                    id: "10",
                                                    text: "Consultório odontológico"
                                                },
                                                {
                                                    id: "11",
                                                    text: "Copiadora"
                                                },
                                                {
                                                    id: "12",
                                                    text: "Escola de idiomas"
                                                },
                                                {
                                                    id: "13",
                                                    text: "Escola de informática"
                                                },
                                                {
                                                    id: "14",
                                                    text: "Escola ou colégio"
                                                },
                                                {
                                                    id: "15",
                                                    text: "Escola técnica"
                                                },
                                                {
                                                    id: "16",
                                                    text: "Escritório"
                                                },
                                                {
                                                    id: "17",
                                                    text: "Farmácia"
                                                },
                                                {
                                                    id: "18",
                                                    text: "Floricultura"
                                                },
                                                {
                                                    id: "19",
                                                    text: "Hotel"
                                                },
                                                {
                                                    id: "20",
                                                    text: "Igreja"
                                                },
                                                {
                                                    id: "21",
                                                    text: "Lavanderia"
                                                },
                                                {
                                                    id: "22",
                                                    text: "Livraria"
                                                },
                                                {
                                                    id: "23",
                                                    text: "Outros"
                                                }
                                                ]
            },
            initState(){
                this.state.placeholder = '- Selecione -'
                this.state.disabled    = false

                axios.post(this.$root.$options.config.environment.applicationUrlApiAutomation + '/api/enterprise/version/1.0/state-list',
                    {
                        config: {
                            token: this.$root.$options.config.token
                        }
                    },{
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${this.$store.state.automationBearer}`
                        }
                    }
                ).then(response => {
                    this.state.options = this.state.options.concat(response.data.data)
                })
            },
            searchCnaeNew(company){
                let clientToken = this.$root.$options.config.token
                let bearerToken = `Bearer ${this.$store.state.automationBearer}`

                return {
                    url: this.$root.$options.config.environment.applicationUrlApiAutomation + '/api/enterprise/version/1.0/cnae-company',
                    dataType: 'json',
                    delay: 1000,
                    beforeSend: function (request) {
                        request.setRequestHeader("Authorization", bearerToken);
                    },
                    data: function (params) {
                        return {
                            config: {
                                token: clientToken
                            },
                            data: {
                                company: company,
                                description:  params.term
                            }
                        };
                    },
                    processResults: function (data, params) {
                        return {
                            results: data.data.map(obj => {
                                return {
                                    id: obj.id,
                                    text: obj.text,
                                    html: '<div><b>'+obj.text+'</b></div><div style="font-size:x-small">'+obj.company+'</div>',
                                }
                            })
                        };
                    },
                    cache: true,
                }
            },
            searchCnaeByIdNew(idCnae){
                if (this.CnaeSearched || !idCnae)
                    return

                axios.post(this.$root.$options.config.environment.applicationUrlApiAutomation + '/api/enterprise/version/1.0/cnae-company',
                    {
                        config: {
                            token: this.$root.$options.config.token
                        },
                        data: {
                            id: idCnae
                        }
                    },{
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${this.$store.state.automationBearer}`
                        }
                    }
                ).then(response => {
                    if (!response.data.data)
                        return

                        const index = this.activityList.findIndex(activity => activity.company == response.data.data[0].company);
                        if (index !== -1) {
                            this.activityList[index].cnaeOptions = response.data.data;
                        }
                        this.prepareCnaeCompany()
                    })
            },
        },
    }
</script>

<style lang="scss" scoped>
    .m-0 {
        margin-bottom: 15px !important;
    }
    .labelCheckbox {
        padding-left: 10px;
        vertical-align: middle;
    }
</style>




// WEBPACK FOOTER //
// FormPartialEnterprise.vue?e8108a12